import React from 'react';

import { Editor } from '@tinymce/tinymce-react';

import configuration from './configuration';

import './main.less';

function EditorField({ input }) {
	return (
		<Editor
			init={configuration}
			value={input.value}
			onEditorChange={(v) => input.onChange(v)}
		/>
	);
}

export default EditorField;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article/editor/editor-field/main.js